import {FileManager} from '../../shared/Models/FileManager';
import {InvoiceLayoutDetails} from './InvoiceLayoutDetails';

export class InvoiceLayout {

  static LAYOUT_TYPE_INVOICE = 0;
  static LAYOUT_TYPE_CREDIT = 1;

  public id: number;
  public name: string;
  public title: string;
  public status;
  public position: number;
  public invoiceLayoutDetails: InvoiceLayoutDetails[] = [];
  public logo: FileManager;
  public header: string;
  public footer: string;
  public isCredit: any;
}
